import { ResizeableType, WBComponent } from "./WBComponent";

import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";

import CreateAttributeList, { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { getNodeComponentAttributeValue, getNodeStyleAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import MySiteIcon from "vagaro-website-rendering/src/components/Icons/MySiteIcon"
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";




export default class WBFooter extends WBComponent{

    constructor(){
        super();
        this.typename = wBComponentTypeNames.footer;
        this.isStatic = true;
        this.displayName = "Footer";
        this.resizeType = ResizeableType.VerticalOnly;

        this.resizeVisibilty = [true, true,  false]
        this.editList = [ "whiteLabel","footerType",componentAttributeTypes.overlayColor,...CreateAttributeList(false,true,true,true,false,false).filter(a=>a!="width")];
        this.primaryEditAttributes = ["footerType","whiteLabel"];
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 640 512"><path d="M323.7 62.6C355.1 54.7 390.3 48 416 48c41.2 0 89.8 10.6 126.5 28.9C582 96.7 592 116.3 592 128c0 9.4-5.1 21.5-35.9 33.1c-29.4 11.1-67 14.9-92.1 14.9c-34.7 0-53.5-10.4-80.2-25.7l-.7-.4c-20.6-11.8-45.1-25.8-79.1-33V67.8c6-1.7 12.7-3.4 19.7-5.2zM256 160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0C352.3 0 256 32 256 32v80 48h0zM128 96c0 35.3 28.7 64 64 64h32V32H192c-35.3 0-64 28.7-64 64zm67.7 353.4c-7-1.8-13.7-3.5-19.7-5.2V395.1c34-7.3 58.5-21.3 79.1-33l.7-.4C282.5 346.4 301.3 336 336 336c25.2 0 62.7 3.7 92.1 14.9C458.9 362.5 464 374.6 464 384c0 11.7-10 31.3-49.5 51.1C377.8 453.4 329.2 464 288 464c-25.7 0-60.9-6.7-92.3-14.6zM128 352h0v48 80s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32zM0 416c0 35.3 28.7 64 64 64H96V352H64c-35.3 0-64 28.7-64 64z"/></svg>
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {

        return [
            new AttributeDefinition("whiteLabel", "White Label (Admin Only)","", AttributeInputType.WhiteLabel, [
                { label: "Off", value: "" },
                { label: "On", value: "on" },

            ]),
            new AttributeDefinition("footerType","Content Width","",AttributeInputType.ButtonField,
            [{label:"Full Width",value:""},{label:"Fit to Page",value:"fit"}]

            ),
        ]

    }

    RenderLayout({component,children,screenSize,isEditor,userContext}:WBRenderProps): JSX.Element {


        const isCondensed = getNodeComponentAttributeValue(component,"footerType","")=="fit";

        let pageWidthString = "var(--half-width)";

        const width = `calc(50% - ${pageWidthString})`;

        const tag = getNodeComponentAttributeValue(component,"tag","");

        const tagInfo = tag.length>0?{sectiontag:tag}:{};
        const isWhiteLable = getNodeComponentAttributeValue(component,"whiteLabel","")=="on";
        const wlcls = (!isWhiteLable)?"wl":"";

        const atts = GetNodeDomAttributes("v-section v-footer "+wlcls,component,screenSize,isEditor);




        if(getNodeStyleAttributeValue(component,ScreenSize.Mobile,"height","")!=""){

            setNodeStyleAttributeValue(component,ScreenSize.Mobile,"height","");
        }




        return (

          <>
            <div {...atts}  {...tagInfo}   >



                 <>
                {isCondensed&&<div className="section-buffer" style= {{width:width}}></div>}

                {children}

                {isCondensed&&<div className="section-buffer"  style= {{width:width}}></div>}
                </>

                {!isWhiteLable&& <div {...atts} id="" style={{...atts.style,height:"auto",padding:"4px",maxHeight:"40px",minHeight:"40px",position:"absolute",bottom:"0px",width:"100%"}} className={ component.tokenClasses+ " w-full center-all "} >
                <a className="no-a inherit-color center-all" style={{gap:"3px"}} href="https://www.vagaro.com/pro/booking-website-builder" rel='noreferrer' target="_blank"><MySiteIcon/><span style={{fontFamily:'proxima-nova',fontSize:"12px",fontWeight:"400",lineHeight:"15px"}}> powered by Vagaro</span></a>
              </div>}

            </div>


            </>
        )



        // return <RenderSection

        // atts={GetNodeDomAttributes("v-section v-footer ",component,screenSize,isEditor)}
        // component={component} screenSize={screenSize} userContext={userContext} isEditor={isEditor}>{children}</RenderSection>

    }

}
